export default {
  title: {
    management: '满意度调查管理',
    invitation: '满意度调查邀请记录',
    question: {
      add: '新增满意度调查问题',
      edit: '编辑满意度调查问题'
    },
    step: {
      add: '新增满意度调查流程',
      edit: '编辑满意度调查流程'
    },
    questionnaire: {
      add: '新增满意度调查问卷',
      edit: '编辑满意度调查问卷'
    },
    microSite: {
      add: '新增满意度调查微网站',
      edit: '编辑满意度调查微网站'
    },
    emailTemplate: {
      add: '新增邮件模板',
      edit: '编辑邮件模板'
    },
    iconSelector: '选择图标',
    questionSelector: '选择满意度调查字段',
    stepSelector: '选择满意度调查流程'
  },
  menu: {
    management: '满意度调查管理',
    invitation: '满意度调查邀请记录'
  },
  tabMenu: {
    microSite: '满意度调查微网站',
    questionnaire: '调查问卷',
    step: '流程',
    question: '问题',
    emailTemplate: '邮件模板'
  },
  questionType: {
    text: '文本',
    date: '日期',
    single: '单选',
    multiple: '多选',
    attachment: '附件',
    link: '协议超链接',
    location: '所在地',
    country: '国家/地区',
    province: '省份',
    city: '城市',
    nationality: '国籍',
    language: '语言',
    nps: 'nps',
    stars: '六分制问题'
  },
  questionnaireType: {
    candidateApply: '求职者申请满意度调查',
    candidateInterview: '求职者面试满意度调查',
    hmScore: ' 招聘经理评估满意度调查',
    hmInterview: '招聘经理面试满意度调查',
    general: '手动发送问卷'
  },
  emailTemplateType: {
    candidateSurvey: '自动发送-求职者面试调查',
    HMSurvey: '自动发送-招聘经理评估调查',
    HMInterviewSurvey: '自动发送-招聘经理面试调查',
    defaultSurvey: '手动发送'
  },
  language: {
    cn: '简体中文',
    tc: '繁体中文',
    en: '英文'
  },
  label: {
    question: '问卷字段',
    questionName: '字段名称',
    questionType: '字段类型',
    questionStatus: '字段状态',
    questionOption: '字段选项',
    optionNo: '选项{number}',
    step: '问卷流程',
    stepName: '流程名称',
    stepIcon: '流程图标',
    stepStatus: '流程状态',
    isRequiredQuestion: '必填字段',
    questionnaireStatus: '问卷状态',
    questionnaireName: '问卷名称',
    questionnaireType: '问卷类型',
    micrositeName: '微网站名称',
    micrositeTitle: '标题',
    micrositeUrl: '预览链接',
    micrositeIsFinished: '完成设计',
    micrositeStatus: '状态',
    emailSubject: '邮件标题',
    emailType: '邮件类型',
    microsite: '微网站',
    invitationDate: '邀请日期',
    satisfactionSurveyDate: '完成日期',
    export: '导出',
    recruiter: '招聘人员',
    operation: '操作',
    questionnaire: '满意度调查问卷',
    candidate: '求职者',
    company: '公司',
    job: '职位',
    status: '状态',
    finished: '已完成',
    unfinished: '未完成',
    keywordsSearch: '关键字搜索',
    noticeSuccessMessage: '提醒候选人成功！',
    operationBtn: {
      notice: '提醒候选人',
      cancel: '取消邀请',
      view: '查看候选人'
    },
    statusList: {
      all: '全部状态',
      invited: '已邀请',
      finished: '已完成',
      cancelled: '已取消'
    },
    title: {
      cn: '@:admin.company.satisfactionSurvey.language.cn标题',
      tc: '@:admin.company.satisfactionSurvey.language.tc标题',
      en: '@:admin.company.satisfactionSurvey.language.en标题'
    },
    name: {
      cn: '@:admin.company.satisfactionSurvey.language.cn名称',
      tc: '@:admin.company.satisfactionSurvey.language.tc名称',
      en: '@:admin.company.satisfactionSurvey.language.en名称',
      country: {
        cn: '国家/地区字段@:admin.company.satisfactionSurvey.language.cn名称',
        tc: '国家/地区字段@:admin.company.satisfactionSurvey.language.tc名称',
        en: '国家/地区字段@:admin.company.satisfactionSurvey.language.en名称'
      },
      province: {
        cn: '省份字段@:admin.company.satisfactionSurvey.language.cn名称',
        tc: '省份字段@:admin.company.satisfactionSurvey.language.tc名称',
        en: '省份字段@:admin.company.satisfactionSurvey.language.en名称'
      },
      city: {
        cn: '城市字段@:admin.company.satisfactionSurvey.language.cn名称',
        tc: '城市字段@:admin.company.satisfactionSurvey.language.tc名称',
        en: '城市字段@:admin.company.satisfactionSurvey.language.en名称'
      }
    },
    placeholder: {
      cn: '@:admin.company.satisfactionSurvey.language.cn占位符',
      tc: '@:admin.company.satisfactionSurvey.language.tc占位符',
      en: '@:admin.company.satisfactionSurvey.language.en占位符',
      country: {
        cn: '国家/地区字段@:admin.company.satisfactionSurvey.language.cn占位符',
        tc: '国家/地区字段@:admin.company.satisfactionSurvey.language.tc占位符',
        en: '国家/地区字段@:admin.company.satisfactionSurvey.language.en占位符'
      },
      province: {
        cn: '省份字段@:admin.company.satisfactionSurvey.language.cn占位符',
        tc: '省份字段@:admin.company.satisfactionSurvey.language.tc占位符',
        en: '省份字段@:admin.company.satisfactionSurvey.language.en占位符'
      },
      city: {
        cn: '城市字段@:admin.company.satisfactionSurvey.language.cn占位符',
        tc: '城市字段@:admin.company.satisfactionSurvey.language.tc占位符',
        en: '城市字段@:admin.company.satisfactionSurvey.language.en占位符'
      }
    },
    agreementLink: {
      cn: '@:admin.company.satisfactionSurvey.language.cn协议链接',
      tc: '@:admin.company.satisfactionSurvey.language.tc协议链接',
      en: '@:admin.company.satisfactionSurvey.language.en协议链接'
    }
  },
  placeholder: {
    searchKeyword: {
      question: '请输入字段名称',
      step: '请输入流程名称'
    },
    questionnaireName: '请输入问卷名称',
    step: '请选择满意度调查流程',
    stepName: '请输入流程名称',
    question: '请选择满意度调查字段',
    questionName: '请输入字段名称',
    questionType: '请选择字段类型',
    agreementLink: '请输入协议链接',
    placeholder: '请输入占位符',
    optionName: '请输入选项名称',
    questionnaireType: '请选择满意度调查类型',
    questionnaireStatus: '请选择问卷类型',
    emailSubject: '请输入邮件标题',
    emailTemplate: '请输入邮件模板',
    micrositeName: '请输入微网站名称',
    selectMicrositeName: '请选择微网站名称'
  },
  message: {
    questionNameRequired: '请输入字段名称',
    questionTypeRequired: '请选择字段类型',
    agreementLinkRequired: '请输入协议链接',
    optionNameRequired: '请输入选项名称',
    stepNameRequired: '请输入流程名称',
    stepQuestionsRequired: '请选择满意度调查字段',
    NPSQuestionSingle: '一个调查只能有一个净推荐值问题',
    stepIconRequired: '请选择流程图标',
    questionnaireStepsRequired: '请选择满意度调查流程',
    questionnaireNameRequired: '请输入问卷名称',
    questionnaireMicroSiteRequired: '请选择微网站',
    NPSStepSingle: '一个调查只能有一个净推荐值问题',
    questionnaireTypeRequired: '请选择满意度调查类型',
    emailSubjectRequired: '请输入邮件标题',
    emailTemplateRequired: '请输入邮件模板',
    emailTemplateTip: {
      warn: `
        请<span class="strong">不要</span>移除下方编辑框内形如<span class="strong">{{first_name}}</span>的占位符。
        <br/>
        您可以编辑占位符的样式来调整系统默认文案的样式，例如字体，字号等。
      `,
      description: `
        <tr>
          <th>占位符</th>
          <th>值/描述</th>
        </tr>
        <tr>
          <td>{{questionnaire_page_link}}</td>
          <td>邀请时所选的页面链接</td>
        </tr>
        <tr>
          <td>{{first_name}}</td>
          <td>所邀请求职者的名字</td>
        </tr>
        <tr>
          <td>{{last_name}}</td>
          <td>所邀请求职者的姓氏</td>
        </tr>
        <tr>
          <td>{{hr_first_name}}</td>
          <td>HR的名字</td>
        </tr>
        <tr>
          <td>{{hr_last_name}}</td>
          <td>HR的姓氏</td>
        </tr>
        <tr>
          <td>{{candidate_profile_link}}</td>
          <td>求职者个人信息页面链接</td>
        </tr>
        <tr>
          <td>{{questionnaire_page_qrcode}}</td>
          <td>事件二维码</td>
        </tr>
      `
    },
    testEmailHasSent: '测试邮件发送成功！'
  },
  btn: {
    saveAndDesign: '保存并去设计',
    goDesign: '去设计',
    sendTestEmail: '发送测试邮件'
  },
  microsite: {
    micrositeName: '微网站名称',
    micrositeLink: '微网站链接',
    webEnLink: '电脑端 （英文）',
    webCnLink: '电脑端 （简中）',
    webTcLink: '电脑端 （繁中）',
    mobileEnLink: '手机端 （英文）',
    mobileCnLink: '手机端 （简中）',
    mobileTcLink: '手机端 （繁中）'
  },
  headerImage: {
    tipMessage: {
      pc: '推荐大小为：1920*750且小于5MB',
      mobile: '推荐大小为：750*450且小于5MB'
    }
  }
}
